/* eslint-disable no-console */
import React, { useContext, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Form } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import { CalloutContext, useOkapiKy } from '@folio/stripes/core';
import useBarcodeGeneral from '../../../../../../hooks/Barcode/useBarcodeGeneral';
import GeneratorCard from './GeneratorCard';

function BarcodeGeneratorSettings() {
  const { generalSettings, isLoading, configId } = useBarcodeGeneral();
  const [initialValues, setInitialValues] = useState({});
  const okapiKy = useOkapiKy();
  const context = useContext(CalloutContext);

  useEffect(() => {
    if (generalSettings) {
      setInitialValues(generalSettings);
    } else {
      setInitialValues({
        enableGenerator: false,
        autoGenerate: false,
      });
    }
  }, [generalSettings]);

  const onChangeGeneralSettings = (values) => {
    if (configId) {
      okapiKy
        .put(`inventory-templates-configs/${configId}`, {
          timeout: 30000,
          method: 'PUT',
          json: {
            id: configId,
            configName: 'generatorSettings',
            configCode: 'generatorSettings',
            configValue: values,
          },
        })
        .then((res) => {
          if (res.ok) {
            setInitialValues(values);
            const message = (
              <FormattedMessage
                id="ui-plugin-inventory-templates.barcodeGeneralSettings.autoGenerateOptions.callout.updated"
                defaultMessage="Barcode general settings config updated successfully"
              />
            );
            context.sendCallout({ message, type: 'success' });
          }
        })
        .catch(async (err) => {
          console.log(err);
          const res = err.response;
          const text = await res.text();
          console.log(text);
          context.sendCallout({ message: text, type: 'error' });
        });
    } else {
      okapiKy
        .post('inventory-templates-configs', {
          timeout: 30000,
          method: 'POST',
          json: {
            configName: 'generatorSettings',
            configCode: 'generatorSettings',
            configValue: values,
          },
        })
        .then((res) => {
          if (res.totalRecords < 0) {
            setInitialValues(values);
            const message = (
              <FormattedMessage
                id="ui-plugin-inventory-templates.barcodeGeneralSettings.autoGenerateOptions.callout.created"
                defaultMessage="Barcode general settings config created successfully"
              />
            );
            context.sendCallout({ message, type: 'success' });
          }
        })
        .catch(async (err) => {
          console.log(err);
          const res = err.response;
          const text = await res.text();
          console.log(text);
          context.sendCallout({ message: text, type: 'error' });
        });
    }
  };

  const onHandleSubmit = (values) => {
    console.log(values);
    onChangeGeneralSettings(values);
  };

  return (
    <Form
      onSubmit={onHandleSubmit}
      initialValues={initialValues}
      mutators={{
        ...arrayMutators,
      }}
    >
      {({ handleSubmit, pristine, submitting, form }) => {
        return (
          <form id="barcode-general-form" onSubmit={handleSubmit}>
            <GeneratorCard
              form={form}
              isLoading={isLoading}
              pristine={pristine}
              submitting={submitting}
            />
          </form>
        );
      }}
    </Form>
  );
}

export default BarcodeGeneratorSettings;
